import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { debounce } from "lodash";
import { imagesList, imagesListNext, uploadImage } from "../../actions";
import List from "../../components/List";
import ImageMiniListItem from "../../components/ImageMiniListItem";
import { Toolbar, ToolbarGroup } from "../../components/Toolbar";
import UploadButton from "../../components/UploadButton";

import styles from "./ImageMiniPicker.module.css";

const identity = (data) => data;

export class ImageMiniPicker extends Component {
  constructor(props) {
    super(props);
    this.renderEmail = this.renderEmail.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.search = debounce(this.search.bind(this), 300);
    this.onScroll = debounce(this.onScroll.bind(this), 300);
    this.searchRef = createRef();
    this.scrollRef = createRef();
  }

  componentWillMount() {
    this.props.imagesList(this.props.accountId, true);
    this.fetchMore = this.fetchMore.bind(this);
  }

  fetchMore() {
    this.props.imagesListNext(this.props.accountId);
  }

  uploadFile(e) {
    var file = e.currentTarget.files[0];
    this.props.uploadImage(this.props.accountId, file).then(() => {
      this.props.imagesList(this.props.accountId, null, true);
    });
  }

  onSearch(e) {
    const searchTerm = e.currentTarget.value;
    this.search(searchTerm);
  }

  search(searchTerm) {
    this.props.imagesList(
      this.props.accountId,
      {
        name: searchTerm,
      },
      true
    );
  }

  onScroll(e) {
    if (this.scrollRef?.current) {
      if (
        this.scrollRef.current.scrollTop + this.scrollRef.current.clientHeight >
        this.scrollRef.current.scrollHeight - 50
      ) {
        this.props.imagesListNext();
      }
    }
  }

  renderFetching() {
    return <div>Fetching</div>;
  }

  renderEmail(email) {
    return (
      <ImageMiniListItem
        email={email}
        key={email.id}
        accountId={this.props.accountId}
        onSelect={this.props.onSelect}
      />
    );
  }

  render() {
    const { images, isFetching, visible } = this.props;

    return (
      <div className={styles.container + (visible ? " " + styles.open : "")}>
        <Toolbar>
          <ToolbarGroup>
            <input
              ref={this.searchRef}
              placeholder="Search"
              style={{ width: "100%" }}
              onChange={this.onSearch}
            />
          </ToolbarGroup>
          <ToolbarGroup width="100" align="right">
            <UploadButton onChange={this.uploadFile}>Upload</UploadButton>
          </ToolbarGroup>
        </Toolbar>
        <div
          className={styles.imagesContainer}
          ref={this.scrollRef}
          onScroll={this.onScroll}
        >
          <List
            renderItem={this.renderEmail}
            items={images}
            isFetching={isFetching}
            loadMore={this.fetchMore}
            renderFetching={this.renderFetching}
          />
        </div>
      </div>
    );
  }
}

ImageMiniPicker.propTypes = {
  imagesList: PropTypes.func.isRequired,
  imagesListNext: PropTypes.func.isRequired,
  images: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const imagesPagination = state.pagination.images || {};
  const images = (imagesPagination.ids || [])
    .map((id) => state.entities.image[id])
    .filter(identity);
  const isFetching = imagesPagination.isFetching;

  return {
    images,
    isFetching,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  imagesList,
  imagesListNext,
  uploadImage,
})(ImageMiniPicker);
